import React, { Dispatch, SetStateAction, useCallback } from 'react'
import { Container, Header, Title, ExpandButton, Content } from './styles'
import { IconComponent } from '~/assets/icons/component'

type Props = React.PropsWithChildren<{
  title: string
  expanded: boolean
  setExpanded: Dispatch<SetStateAction<boolean>>
}>

const HealthProcedureAccordionCardList: React.FC<Props> = ({ title, children, expanded, setExpanded }: Props) => {
  const handleOnClick = useCallback(() => {
    setExpanded(isExpanded => !isExpanded)
  }, [expanded])

  return (
    <Container>
      <Header onClick={handleOnClick}>
        <Title role="heading">{title}</Title>
        <ExpandButton aria-label="expand-health-procedures-card-list" expanded={expanded}>
          <IconComponent name="chevronDown" />
        </ExpandButton>
      </Header>
      <Content data-testid="accordion-content" expanded={expanded}>
        {children}
      </Content>
    </Container>
  )
}

export { HealthProcedureAccordionCardList }
